import React from 'react';
import ExperimentBucketing from '|/app/developer-control-panel/experiment-bucketing';
import FeatureBranches from '|/app/developer-control-panel/feature-branches';
import MfeDevOverride from '|/app/developer-control-panel/mfe-dev-override';
import styles from './control-panel.module.css';

const DeveloperControlPanel = () => {
  return (
    <div className={styles.debuggerContainer}>
      <ExperimentBucketing />
      <FeatureBranches />
      <MfeDevOverride />
    </div>
  );
};

export default DeveloperControlPanel;
